import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    color: theme.palette.common.black,
    display: 'grid',
    gridGap: 24,
  },
  locationAndPay: {
    display: 'grid',
    alignItems: 'center',
    backgroundColor: theme.palette.common.gray100,
    borderRadius: 5,
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  innerText: {
    display: 'flex',
  },
  icons: {
    color: theme.palette.common.gray800,
    marginRight: theme.spacing(2),
  },
}));
